/**
 * IP Geolocation Types
 * Based on ipwho.is API response
 */

export interface IPGeolocation {
    ip: string;
    success: boolean;
    type?: string;
    continent?: string;
    continent_code?: string;
    country?: string;
    country_code?: string;
    region?: string;
    region_code?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    is_eu?: boolean;
    postal?: string;
    calling_code?: string;
    capital?: string;
    borders?: string;
    flag?: {
        img: string;
        emoji: string;
        emoji_unicode: string;
    };
    connection?: {
        asn: number;
        org: string;
        isp: string;
        domain: string;
    };
    timezone?: {
        id: string;
        abbr: string;
        is_dst: boolean;
        offset: number;
        utc: string;
        current_time: string;
    };
    message?: string; // Error message if success is false
}

/**
 * Simplified geolocation data for display
 */
export interface IPGeolocationSummary {
    ip: string;
    country: string;
    countryCode: string;
    city: string;
    region: string;
    latitude: number;
    longitude: number;
    flag: string;
    isp: string;
    org: string;
    timezone: string;
    isEU: boolean;
}

/**
 * Convert full IPGeolocation response to summary
 */
export function toGeolocationSummary(data: IPGeolocation): IPGeolocationSummary | null {
    if (!data.success) {
        return null;
    }

    return {
        ip: data.ip,
        country: data.country || 'Unknown',
        countryCode: data.country_code || '',
        city: data.city || 'Unknown',
        region: data.region || '',
        latitude: data.latitude || 0,
        longitude: data.longitude || 0,
        flag: data.flag?.emoji || '',
        isp: data.connection?.isp || 'Unknown',
        org: data.connection?.org || 'Unknown',
        timezone: data.timezone?.id || 'Unknown',
        isEU: data.is_eu || false
    };
}
